module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-926abddcbaa79e332b1fea76c70ec023.jpg";